import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/terms.scss";

const termsSections = [
  {
    title: "Using this site",
    paragraphs: [
      "By accessing this site or placing an order, you agree to these terms and our Privacy Policy. You must be legally able to enter a binding agreement and provide accurate, current information when using checkout.",
      "You may use the site only for personal, lawful purposes. Attempts to disrupt the site, bypass security, scrape content at scale, introduce malicious code, or use another person’s information without permission are prohibited.",
    ],
  },
  {
    title: "Products and availability",
    paragraphs: [
      "We make reasonable efforts to describe products, colors, materials, and measurements accurately. Screens display color differently, and handmade or garment-dyed pieces may have natural variation. These differences are not defects.",
      "Products are subject to availability. Adding an item to a cart does not reserve it, and we may set purchase limits when stock is limited.",
    ],
  },
  {
    title: "Orders and payment",
    paragraphs: [
      "An order is an offer to purchase. We may decline or cancel it before shipment for reasons including unavailable stock, suspected fraud, payment authorization failure, or an obvious pricing error. If payment has been collected for a canceled order, it will be refunded.",
      "Prices are shown in the currency indicated at checkout. Taxes, shipping, duties, and other charges are displayed when they can be calculated and remain the customer’s responsibility as described during checkout.",
    ],
  },
  {
    title: "Shipping, title, and risk",
    paragraphs: [
      "Delivery dates are estimates rather than guarantees. Carrier delays, customs processing, weather, and events beyond our reasonable control may affect timing. Responsibility for an order transfers as provided by applicable consumer law and the selected shipping service.",
      "You are responsible for providing a complete, deliverable address and for reviewing shipping details before submitting an order.",
    ],
  },
  {
    title: "Returns",
    paragraphs: [
      "Eligible purchases may be returned according to the Returns Policy in effect on the order date. Items must meet the stated condition and timing requirements. Your statutory consumer rights, where applicable, are not limited by that policy.",
    ],
  },
  {
    title: "Intellectual property",
    paragraphs: [
      `The site and its text, photographs, graphics, product designs, trademarks, and other content belong to ${siteConfig.brandName} or its licensors. You may view and use the site for personal shopping, but may not reproduce, modify, distribute, sell, or commercially exploit its content without written permission.`,
    ],
  },
  {
    title: "Third-party services",
    paragraphs: [
      "Checkout, payments, maps, social platforms, and other site features may be provided by third parties with their own terms and privacy practices. We are not responsible for third-party sites reached through external links.",
    ],
  },
  {
    title: "Disclaimers and liability",
    paragraphs: [
      "To the extent permitted by law, the site is provided without guarantees that it will always be uninterrupted or error-free. We are not liable for indirect, incidental, or consequential loss arising from use of the site.",
      "Nothing in these terms excludes liability that cannot legally be excluded, or limits mandatory rights available to consumers. Where liability may be limited, our total liability relating to a purchase will not exceed the amount paid for that purchase.",
    ],
  },
  {
    title: "Changes and governing law",
    paragraphs: [
      "We may update these terms from time to time. The version posted when you place an order applies to that purchase. These terms are governed by the laws applicable to our operating entity, without limiting protections you receive under mandatory local consumer law.",
    ],
  },
];

function Terms() {
  return (
    <main className="terms-page">
      <header className="terms-page__header">
        <p className="terms-page__eyebrow">Legal</p>
        <h1>Terms &amp; conditions</h1>
        <p>Last updated August 15, 2026</p>
      </header>

      <div className="terms-page__intro">
        <p>
          These terms set out the rules for using the {siteConfig.brandName}
          website and buying from our online store. Please read them before
          placing an order.
        </p>
      </div>

      <div className="terms-page__content">
        {termsSections.map((section, index) => (
          <section key={section.title} aria-labelledby={`terms-section-${index}`}>
            <span>{String(index + 1).padStart(2, "0")}</span>
            <div>
              <h2 id={`terms-section-${index}`}>{section.title}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </section>
        ))}
      </div>

      <section className="terms-page__contact">
        <p className="terms-page__eyebrow">Questions?</p>
        <h2>We are here to help.</h2>
        <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
      </section>
    </main>
  );
}

export default Terms;
